<div class="background" [ngStyle]="imageUrl ? { 'background-image': 'url(' + imageUrl + ')' } : {}"></div>

<div appBgOpacityScroll>
  <app-main-navbar></app-main-navbar>
  <div class="container-fluid">
    <router-outlet></router-outlet>
  </div>
</div>

